<div
  class="mw-notification-banner"
  [ngClass]="bannerClass"
  [id]="alertId"
  *ngIf="isDisplayed"
>
  <div class="mw-notification-banner__start">
    <mat-icon class="mw-icon-16" *ngIf="showIcon">
      {{ icon ?? 'error_outline' }}
    </mat-icon>
    <div class="mw-notification-banner__content">
      <div class="pr-[4px] text-caption font-medium">
        {{ title | translate }}
      </div>
      <div class="text-caption">
        {{ text | translate }}
      </div>
    </div>
  </div>
  <div class="mw-notification-banner__end pl-[40px] pr-[16px]">
    <ng-container
      *ngTemplateOutlet="actionsTemplate || actionsTemplateFromConfig"
    ></ng-container>
    <mat-icon
      class="mw-icon-24 mw-pointer ml-[24px]"
      *ngIf="enableCloseBtn"
      (click)="onClose()"
    >
      close
    </mat-icon>
  </div>
</div>
